<template>
  <div>
    <md-empty-state
      class="md-primary md-small"
      md-icon="done"
      md-label="Done"
      md-description="We have received your booking request. We'll contact you shortly. Thank you!"
    ></md-empty-state>
  </div>
</template>

<script>
export default {
  name: "BookingCompleted",
};
</script>

<style>
</style>